import { ContainerProps } from '../../interfaces/container.interface'
import c from 'classnames'
import styles from './Subtitle.module.scss'

const SubTitleComponent = ({ children }: ContainerProps) => {
    return (
        <h2 className={c(styles.subtitle, 'animate__animated animate__fadeInUp')}>{children}</h2>
    )
}

export default SubTitleComponent
